export function PrizePriceConfirmation({ name, previous, next, currency, busy, onConfirm, onCancel }: {
  name: string; previous: number; next: number; currency: string; busy: boolean;
  onConfirm: () => void; onCancel: () => void;
}) {
  return <section aria-label="Confirm prize price change">
    <h3>Confirm the new price for {name}</h3>
    <p>Current price: {previous} {currency}. New price: {next} {currency}.</p>
    <p>This changes the prize price for every child with this prize on their shelf. Existing requests keep their saved price.</p>
    <button type="button" className="button ghost" onClick={onCancel} disabled={busy}>Keep editing</button>
    <button type="button" className="button primary" onClick={onConfirm} disabled={busy}>{busy ? 'Saving…' : 'Confirm price change'}</button>
  </section>;
}
